import { CiCalendar } from "react-icons/ci";
import { BsCalendarCheck } from "react-icons/bs"; // Icône "rendez-vous pris"
import { useState } from "react";
import { Link } from "react-router-dom";

const BookingButton = ({ label = "Prendre rendez-vous" }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Link
      to="/cart"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="group relative bg-primary text-white py-2 px-6 min-w-[9rem] flex items-center justify-center gap-3 transition-all duration-700 ease-[cubic-bezier(0.510,0.026,0.368,1.016)] shadow-[inset_0_0_0.5px_#ffffff40] hover:bg-white hover:text-black"
    >
      <span className="transition-all duration-700 ease-[cubic-bezier(0.510,0.026,0.368,1.016)]">
        {hovered ? (
          <BsCalendarCheck size={20} className="text-black" />
        ) : (
          <CiCalendar size={20} className="text-white" />
        )}
      </span>
      <span className="font-nunito font-semibold text-[14px] text-white group-hover:text-black transition-all duration-700 ease-[cubic-bezier(0.510,0.026,0.368,1.016)]">
        {label}
      </span>
    </Link>
  );
};

export default BookingButton;
